<mat-card style="width: max-content; max-width: 100%;">
    <mat-card-header>
        <div class="g-just-flex flex-between w-100 flex-wrap gap-20" style="justify-content: space-between;">
            <div class="left">
                <mat-card-title>Appointments</mat-card-title>
                <mat-card-subtitle>Your upcoming and past appointments</mat-card-subtitle>
            </div>
            <div class="right">
                @if(isHealthcareAdmin()) {
                <button mat-flat-button color="primary" routerLink="/app/appointments/add">
                    <mat-icon>add</mat-icon> Book Physical Appointment
                </button>
                }
            </div>
        </div>
    </mat-card-header>

    <div class="status-tabs g-just-flex flex-wrap gap-8 my-12">
        <button mat-stroked-button class="status-tab" [class.active]="selectedStatusTab === 'active'"
            [attr.aria-pressed]="selectedStatusTab === 'active'" [color]="selectedStatusTab === 'active' ? 'primary' : ''"
            (click)="setStatusTab('active')">Active</button>
        <button mat-stroked-button class="status-tab" [class.active]="selectedStatusTab === 'completed'"
            [attr.aria-pressed]="selectedStatusTab === 'completed'"
            [color]="selectedStatusTab === 'completed' ? 'primary' : ''"
            (click)="setStatusTab('completed')">Completed</button>
        <button mat-stroked-button class="status-tab" [class.active]="selectedStatusTab === 'all'"
            [attr.aria-pressed]="selectedStatusTab === 'all'" [color]="selectedStatusTab === 'all' ? 'primary' : ''"
            (click)="setStatusTab('all')">All</button>
        @if(selectedStatusTab === 'custom'){
        <span class="status-tab custom active" aria-live="polite">Custom</span>
        }
    </div>

    <app-table-header [patientsTableFilterArray]="tableFilterArray"
        [patientsFiltersFormControlObject]="tableFiltersFormControlObject" [searchBoxTitle]="'Search appointments...'"
        [hasData]="true" (filterChanged)="onFilterChanged($event)"
        (searchChanged)="onSearchChanged($event)">
    </app-table-header>

    <mat-card-content class="my-12">
        <div *ngIf="loading$ | async" class="g-just-flex flex-center py-20">
            <mat-spinner diameter="40"></mat-spinner>
        </div>
        @if(tableDataSource.data && tableDataSource.data.length > 0){
        <mat-divider></mat-divider>
        <table mat-table matSort [dataSource]="tableDataSource.data" class="mat-elevation-z8 demo-table td-over-tr">
            <!-- Date Column -->
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="date">Date</th>
                <td mat-cell *matCellDef="let element">
                    @let displayDate = element.date || element.start || element.requestedPeriod?.[0]?.start || element.requestedPeriod?.start;
                    @let displayEnd = element.end || element.requestedPeriod?.[0]?.end || element.requestedPeriod?.end;
                    <div class="stacked-cell">
                        @if(displayDate){
                        <div class="primary-line">
                            {{ displayDate | date:'mediumDate' }}
                        </div>
                        <div class="secondary-line subtitle-text-color-2">
                            {{ displayDate | date:'h:mm a' }}
                            @if(displayEnd){
                            <span> - {{ displayEnd | date:'h:mm a' }}</span>
                            }
                        </div>
                        } @else {
                        <span class="subtitle-text-color-2">N/A</span>
                        }
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="patient">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="patient">Patient</th>
                <td mat-cell *matCellDef="let element">
                    @let patientRef = getPatientReference(element);
                    @if(patientRef){
                    <span [appReferenceDisplay]="patientRef" InstantfetchAndRepace="true"></span>
                    } @else {
                    <span class="subtitle-text-color-2">N/A</span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="practitioner">
                <th mat-header-cell *matHeaderCellDef>Practitioner</th>
                <td mat-cell *matCellDef="let element">
                    @let practitionerRefs = getPractitionerReferences(element);
                    @if(practitionerRefs.length){
                    <div class="stacked-cell">
                        @for(practitionerRef of practitionerRefs; track practitionerRef) {
                        <span [appReferenceDisplay]="practitionerRef" [instantFetchAndReplace]="true">
                            {{ practitionerRef }}
                        </span>
                        }
                    </div>
                    } @else {
                    <span class="subtitle-text-color-2">N/A</span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="status">Status</th>
                <td mat-cell *matCellDef="let element">
                    <!-- <span [ngClass]="{
                        'grey': true, 'round': true,
                        'greenbg': element.status === 'fulfilled',
                        'yellowbg': element.status === 'arrived',
                        'bluebg': element.status === 'booked',
                        'redbg': element.status === 'cancelled'
                    }">{{element.status | titlecase}}</span> -->
                                        <span [appChips]="element.status"
                                        [fontSize]="'14px'"
                                        ></span>
                </td>
            </ng-container>

            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="type">Type</th>
                <td mat-cell *matCellDef="let element">
                    <div class="stacked-cell">
                        <div class="primary-line">{{element.displayType}}</div>
                       @if(element.specialtyDisplay) {
                        <div class="tertiary-line"
                        style="white-space: nowrap;"
                        >{{element.specialtyDisplay}}</div>
                        }
                        <div class="secondary-line">
                            <span [appEmphasis]="getAppointmentMode(element)" [fontSize]="'11px'">
                                {{getAppointmentMode(element)}}
                            </span>
                        </div>
                        
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="mode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="mode">Mode</th>
                <td mat-cell *matCellDef="let element">
                    <span
                    [appEmphasis]="getAppointmentMode(element)"
                    >
                {{getAppointmentMode(element)}}
                </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()" >
                    <div class="g-just-flex flex-wrap gap-8" style="width: 300px;
                    justify-content: flex-start;
                    ">
                    <!-- ✅ RESPOND BUTTON - Confirm/Decline with Dialog -->
                    @if(element.status !== 'booked' && element.status !== 'fulfilled' && element.status !==
                    'cancelled'){
                    <button
                    [matTooltip]="'Confirm or decline this appointment'" matTooltipPosition="above" matTooltipClass="tooltip"
                     mat-flat-button color="accent" matTooltip="Confirm or decline this appointment" class="action-btn"
                        (click)="respondToAppointment(element)">
                        <mat-icon class="action-icon">question_answer</mat-icon>
                       
                    </button>
                    }

                    <!-- VIEW DETAILS BUTTON -->
                    <button mat-stroked-button color="primary" matTooltip="View appointment details" class="action-btn"
                        (click)="showAppointmentDetails(element)">
                        <mat-icon class="action-icon">visibility</mat-icon>
                        
                    </button>

                    <!-- REASSIGN BUTTON (for admins on telemedicine) -->
                    @if(isAdmin() ){
                    <button mat-stroked-button color="accent" matTooltip="Reassign to another practitioner" class="action-btn"
                        (click)="reassignPractitioner(element)">
                        <mat-icon class="action-icon"
                        style="padding: 0px !important"
                        >supervisor_account</mat-icon>
                       
                    </button>
                    }

                    <!-- SHIFT CASCADE BUTTON -->
                    @if(isHCA() && isInPersonConsultation(element) && element.status !== 'cancelled' && element.status !== 'fulfilled'){
                    <button mat-stroked-button color="primary" matTooltip="Shift schedule forward" class="action-btn"
                        (click)="openShiftDialog(element)">
                        <mat-icon class="action-icon">fast_forward</mat-icon>
                    </button>
                    }

                    <!-- CANCEL BUTTON -->
                    @if(!isPatient() && element.status === 'booked'){
                    <button mat-stroked-button color="warn" matTooltip="Cancel appointment" class="action-btn"
                        (click)="confirmCancellation(element)">
                        <mat-icon class="action-icon">cancel</mat-icon>
                    </button>
                    }

                    <!-- JOIN MEETING BUTTON (only when meeting link exists) -->
                    @if(hasMeetingLink(element)){
                    <button mat-flat-button color="primary" matTooltip="Open meeting link in a new tab" aria-label="Join meeting" class="action-btn"
                        (click)="openMeetingLink(element)">
                        
                        <mat-icon class="action-icon">videocam</mat-icon>
                    </button>
                    }
</div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns" matHeaderRowDefSticky="true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div class="py-12">
            <mat-paginator
                [length]="(displayedTotal$ | async) || 0"
                [pageSize]="pageSize"
                [pageSizeOptions]="[10,25,50]"
                [disabled]="(tfsLoading$ | async) === true"
                (page)="onPage($event)">
            </mat-paginator>
        </div>
        }@else{
        <app-empty-state [icon]="'event'" [title]="'No Appointments'"></app-empty-state>
        }
    </mat-card-content>
</mat-card>
